var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DField',_vm._g(_vm._b({key:_vm.$vnode.key,attrs:{"mypopup":_vm.mypopup,"service":"Brands","field":"autocomplete","item-text":"name","item-value":"id"},scopedSlots:_vm._u([{key:"form",fn:function({ value, listeners }){return [_c('BrandForm',_vm._g({attrs:{"value":value}},listeners))]}}])},'DField',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }